export const mountFilterByFieldValue = (entity, filter) => {
  if (!filter) return undefined

  return {
    entity,
    fieldId: filter?.fieldValue?.id,
    fieldType: filter?.fieldValue?.type,
    operator: filter?.operator?.id,
    placeType: filter?.fieldValue?.origin,
    value: filter?.value
  }
}
